/* eslint-disable import/order */
import { PATH } from '#const/path';
import AttendingLecture from '#providers/AttendLecture';
import { Chats } from '#providers/Chat';
import CustomerList from '#providers/CustomerList';
import ToastProvider from '#providers/ToastProvider';
import UserInfo from '#providers/UserInfo';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import 'dayjs/locale/ko';
import { CookiesProvider } from 'react-cookie';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Navigate } from 'react-router';
import { RecoilRoot } from 'recoil';
import { ThemeProvider } from 'styled-components';
import App from './App';
import GlobalStyle from './GlobalStyles';
import './styles/color.css';
import './styles/index.css';
import './styles/textStyles.css';
import './styles/wrapper.css';

import theme from './libs/styled-components/theme';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(rootElement);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnWindowFocus: false,
      onError: (err: unknown) => {
        const error = err as AxiosError;
        error.status === 401 && (
          <Navigate
            replace={true}
            to={PATH.SIGN}
            state={{ blockedPagePath: location.pathname + location.search }}
          />
        );
      },
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 5
    }
  }
});
const appWithProvider = (
  <HelmetProvider>
    <CookiesProvider>
      <RecoilRoot>
        <GlobalStyle />
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={theme}>
            <ToastProvider>
              <UserInfo>
                <CustomerList>
                  <Chats>
                    <AttendingLecture>
                      <App />
                    </AttendingLecture>
                  </Chats>
                </CustomerList>
              </UserInfo>
            </ToastProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </RecoilRoot>
    </CookiesProvider>
  </HelmetProvider>
);

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, appWithProvider);
} else {
  root.render(appWithProvider);
}
